<template>
  <div>
    <div class="main" v-if="shopList.length>0">
      <TitleSlot :title="title" :showMore="showMore" :moreDesc="moreDesc" v-if="shopList.length>0"></TitleSlot>
	
      <el-carousel indicator-position="outside" class="outside" :class="(shopList[0].length <=5 )?'minioutside':''">
        <el-carousel-item v-for="(item,i) in shopList" :key="i" class="list">
          <div v-for="(shop,index) in item" :key="index" class="shop" :class="{mini: shopList[0].length <=5}">
            <router-link :to="{name:'auction',params: {goodsId:shop.id}}" target="_blank">
              <div class="shop-img" v-show="shop.cover_img">
                <img v-lazy="shop.cover_img" :alt="shop.name" :key="shop.image_url">
              </div>
              <div class="name">{{shop.name}}</div>
              <div class="price" v-if="shop.auction_status == 1">起拍价： ￥ {{shop.start_price  || 0}}元</div>
              <div class="price" v-else>当前价： ￥ {{shop.current_auction_price || 0}}元</div>

            </router-link>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>
<script>
import TitleSlot from "./TitleSlot.vue";
import chunk from "lodash.chunk";
export default { 
  name: "NewShopList",
  components: {
    TitleSlot
  },
  props: {
    title: {
      type: String,
      default: "部分拍品展示"
    },
    showMore: {
      type: Boolean,
      default: false
    },
    moreDesc: {
      type: String,
      default: "查看全部"
    },
    newsList: {
      type: [Object, Array],
      default: function() {
        return [];
      }
    }
  },
  computed: {
    shopList() {
      return chunk(this.newsList, 10);
    }
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
@import "@/assets/css/mixin.scss";
.main {
  margin-bottom: 20px;
  .outside {
	height: 620px;
	&.minioutside{
		height: 280px;
	}
  }
  .list {
    height: 620px;
    overflow: hidden;
    .shop {
      float: left;
      width: 231px;
      height: 300px;
      background: rgba(255, 255, 255, 1);
      margin-right: 17px;
      cursor: pointer;
      position: relative;
      &.mini {
        height: 280px;
        .name {
          height: 20px;
          @include no-wrap-line(1);
        }
      }
      a {
        display: block;
      }
      &:last-of-type {
        margin-right: 0;
      }
      &:nth-child(5n) {
        margin-right: 0;
      }
       &:nth-child(-n + 5) {
        margin-bottom: 20px;
      }
      .shop-img {
        height: 190px;
        // margin: 20px auto 0;
        // padding: 20px;
        box-sizing: border-box;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .name {
        width: 80%;
        font-size: 13px;
        line-height: 22px;
        font-weight: 400;
        text-align: left;
        margin: 20px auto;
        color:#666;
        @include no-wrap-line(2);
        height: 40px;
      }
      .tags {
        display: flex;
        justify-content: center;
        .tag {
          height: 18px;
          line-height: 18px;
          padding: 0 8px;
          background-color: #83c44e;
          font-size: 10px;
          font-weight: 400;
          color: #fff;
          margin: 5px 4px;
          text-align: center;
        }
      }
      .price {
        height: 16px;
        font-size: 14px;
        color: $price;
        text-align: center;
        padding: 10px 0;
        position: absolute;
        bottom: 10px;
        left: 0;
        width: 100%;
      }
    }
  }
}
</style>

